import {
  USER_ROLE_SALES_REP,
} from 'common/userRoles';

import {
  SR_API_ACTION_ADMIN_GET_USERS_WITH_ROLE,
} from 'api/actionTypes';

export default async function getSalesRepList({ state, apiClient }) {
  if (state.get(['salesReps'])) {
    return;
  }
  await apiClient.postWithState({
    action: SR_API_ACTION_ADMIN_GET_USERS_WITH_ROLE,
    payload: {
      userRole: USER_ROLE_SALES_REP,
    },
    queryId: USER_ROLE_SALES_REP,
    state: state,
    onSuccess(salesReps) {
      state.set(['salesReps'], salesReps);
    },
  });
}
